import React from "react";
import withIconComponent from "../withIconComponent";

var CheckCircle08 = function CheckCircle08() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12l4 4 8-8",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1a11 11 0 1 0 0 22 11 11 0 1 0 0-22z"
  }));
};

export default withIconComponent("UiCheckCircle08", false)(CheckCircle08);